import type { AlbumGridAlbum } from "@/components/album-grid";
import type { LinkTarget } from "@/components/link";

import type { FeaturePageAlbumEntity } from "./feature-page-album-entity";

export interface FeaturePageAlbumGridItem extends AlbumGridAlbum {
  entity: FeaturePageAlbumEntity;
  link: LinkTarget;
}

export function toFeaturePageAlbumGridItem(input: {
  entity: FeaturePageAlbumEntity;
}): FeaturePageAlbumGridItem | null {
  const { entity } = input;
  const workId = entity.entityType === "work" ? entity.id : entity.workId;
  if (!workId) return null;
  const releaseId = entity.entityType === "release" ? entity.id : null;

  return {
    addToListsTarget:
      entity.entityType === "release"
        ? { entityType: "release", releaseId: entity.id, workId }
        : { entityType: "work", workId },
    id: entity.id,
    workId,
    releaseId,
    title: entity.title,
    imageUrl: entity.image?.url ?? null,
    artistDisplay: entity.subtitle,
    year: entity.year,
    entity,
    link: { to: entity.href },
  };
}
